import { useRef, ReactElement } from 'react';

import Button from '~/ui/components/common/Button';
import MainForm from './components/MainForm';
import { IProgram } from '~/services/api/programs/types';
import styles from './ProgramForm.module.scss';

interface IProps {
  initialValues: IProgram;
  isProcessing: boolean;
  onSubmit: (data: IProgram) => void;
  onCancel: () => void;
}

const ProgramForm = ({ initialValues, isProcessing, onSubmit, onCancel }: IProps): ReactElement => {
  const formRef = useRef(null);

  const handleSubmit = () => {
    // call submit form action using ref dispatchEvent
    formRef.current.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
  };

  const onSubmitMainForm = (data: IProgram) => {
    onSubmit({
      ...initialValues,
      ...data,
      rules: initialValues.rules || [],
    });
  };

  return (
    <>
      <MainForm ref={formRef} initialValues={initialValues} onSubmit={onSubmitMainForm} />
      <div className={styles.saveBtnWrapper}>
        <Button
          size="large"
          variant="outlined"
          color="primary"
          disabled={isProcessing}
          onClick={onCancel}
        >
          Cancel
        </Button>
        <Button
          size="large"
          variant="contained"
          color="primary"
          isLoading={isProcessing}
          disabled={isProcessing}
          className={styles.saveButton}
          onClick={handleSubmit}
        >
          Save
        </Button>
      </div>
    </>
  );
};

export default ProgramForm;
